import { Controller } from '@hotwired/stimulus';
import { GoogleCharts } from 'google-charts';

export default class extends Controller {
  static targets = ['map'];

  connect() {
    GoogleCharts.load(this.drawCharts.bind(this), {
      packages: ['geochart'],
    });
  }

  targetsVisible() {
    return this.mapTarget.offsetParent !== null;
  }

  drawCharts() {
    // Target elements are placed on a tab which may not be selected yet.
    // Wait until both targets are visible
    var checkExist = setInterval(() => {
      if (this.targetsVisible()) {
        this.drawMapChart();

        clearInterval(checkExist);
      }
    }, 100);
  }

  drawMapChart() {
    const points = JSON.parse(this.mapTarget.dataset.points);

    var mapData = new GoogleCharts.api.visualization.DataTable();
    mapData.addColumn('number', 'Lat');
    mapData.addColumn('number', 'Long');
    mapData.addColumn({ type: 'string', role: 'tooltip' });
    mapData.addRows(points);

    const mapOptions = {
      width: 600,
      region: 'world',
      displayMode: 'markers',
      legend: false,
      defaultColor: '#b42c87',
      backgroundColor: 'transparent',
      datalessRegionColor: '#b3b3b3',
    };

    const mapChart = new GoogleCharts.api.visualization.GeoChart(
      this.mapTarget,
    );
    mapChart.draw(mapData, mapOptions);
  }
}
